// Bridge helpers for components that don't own the Unity instance (GameChat,
// PlayerProfileOverlay). UnityGame exposes window.sendFlexoMessage while a
// room is mounted; outside a room these return false and do nothing.

type FlexoSender = (type: string, data: unknown) => void;

function flexoSend(type: string, data: unknown): boolean {
  const send = (window as Window & { sendFlexoMessage?: FlexoSender }).sendFlexoMessage;
  if (!send) return false;
  send(type, data);
  return true;
}

/** Play a gesture on the LOCAL character (networks to the room like the emote bar). */
export function sendGameEmote(gestureId: string): boolean {
  return flexoSend('emote', { animation: gestureId });
}

/** Play a gesture on an in-world NPC (npcId = the `npc_*` player id Unity knows). */
export function sendNpcEmote(npcId: string, gestureId: string): boolean {
  return flexoSend('npc_emote', { npcId, animation: gestureId });
}

/**
 * Enter/exit conversation camera framing. partnerId = remote player or `npc_*`
 * id to frame together with the local player; null exits back to orbit.
 */
export function sendConversationFocus(partnerId: string | null): boolean {
  return flexoSend(
    'conversation_focus',
    partnerId ? { partnerId, active: true } : { partnerId: '', active: false }
  );
}

/**
 * Ask Unity to walk/teleport the local avatar adjacent to a guide NPC ("spawn
 * proximity" for the WU-W5 second door). npcId = the `npc_*` player id Unity
 * knows. Forward-compatible: Unity may consume `guide_to_npc` later; unknown
 * bridge message types no-op safely today.
 */
export function sendGuideToNpc(npcId: string): boolean {
  return flexoSend('guide_to_npc', { npcId, walkTo: true });
}

/** Show/hide the private-conversation halo around a set of players (local render). */
export function sendConversationHalo(playerIds: string[], active: boolean): boolean {
  return flexoSend('conversation_halo', { playerIds, active });
}
